import { z } from 'zod';
import { BulkChargeJobId } from '../types/branded';
import { BillingCategorySchema, BulkChargeJobStatusSchema } from '../types/enums';

export const BulkChargeSegmentFiltersSchema = z.object({
  grades: z.array(z.string()).default([]),
  divisions: z.array(z.string()).default([]),
  gender: z.enum(['ALL', 'BOYS', 'GIRLS']).default('ALL'),
  rateCategories: z.array(z.string()).default([]),
});
export type BulkChargeSegmentFilters = z.infer<typeof BulkChargeSegmentFiltersSchema>;

export const BulkChargeJobSchema = z.object({
  id: BulkChargeJobId,
  schoolId: z.string().min(1),
  chargeName: z.string().min(1).max(100),
  amountPerStudent: z.number().positive(),
  billingCategory: BillingCategorySchema,
  dueDate: z.string().min(1),
  segmentFilters: BulkChargeSegmentFiltersSchema,
  notes: z.string().max(500).nullable().optional(),
  studentCount: z.number().int().nonnegative(),
  familyCount: z.number().int().nonnegative(),
  invoiceCount: z.number().int().nonnegative(),
  createdBy: z.string().nullable().optional(),
  status: BulkChargeJobStatusSchema,
  processedInvoiceCount: z.number().int().nonnegative().default(0),
  processedFamilyCount: z.number().int().nonnegative().default(0),
  completedAt: z.string().nullable().optional(),
  lastError: z.string().nullable().optional(),
  createdAt: z.string().min(1),
  updatedAt: z.string().min(1),
});
export type BulkChargeJob = z.infer<typeof BulkChargeJobSchema>;
